import React from 'react';

// 无障碍可点击容器组件 - 为 div 等非交互元素添加键盘支持
function Clickable({
  onClick,
  role = 'button',
  children,
  tabIndex = 0,
  className,
  as: Tag = 'div',
  style,
  ...rest
}) {
  const handleKeyPress = e => {
    const pressedKey = e.key;
    if (pressedKey !== 'Enter' && pressedKey !== ' ') {
      return;
    }
    e.preventDefault();
    onClick?.(e);
  };

  const attrs = {
    ...rest,
    className,
    onClick,
    onKeyDown: handleKeyPress,
    role,
    style,
    tabIndex,
  };

  return <Tag {...attrs}>{children}</Tag>;
}

export default Clickable;
